module.exports = __webpack_public_path__ + "static/media/lora_co2_modbus_en.4786e93f.md";